/**
 * iboCart is a server-side cart owned by an IBO/user pair. Admin pushes items
 * into it (e.g. for reorders). The mock response models a successful push:
 *   - `accepted`: items the server appended.
 *   - `skipped`: items deduped by `sourceOrderId + sku` (idempotency seam).
 */
const iboCartPushResult = {
  iboId: "ibo_42",
  userId: "usr_a1",
  cartId: "cart_ibo_42_usr_a1",
  accepted: [
    {
      sku: "WWG-TS-BLK-M",
      variationId: "var_1",
      quantity: 2,
      sourceOrderId: "ord_5001",
    },
    {
      sku: "WWG-MUG-WHT",
      variationId: null,
      quantity: 1,
      sourceOrderId: "ord_5001",
    },
  ],
  skipped: [],
  cartItemCount: 3,
  pushedAt: "2025-06-22T19:30:00Z",
};

export default iboCartPushResult;
